import "./Header.scss";
import Button from "./Button";

import HeaderLogo from "../../assets/images/header-logo.svg";
import HeaderLogoBtn from "../../assets/images/header-logo-btn.svg";
import { HambergerMenu, Add } from "iconsax-react";
import { useState } from "react";

export default function Header() {
	const [sidebarActive, setSidebarActive] = useState(false);

	const toggleSidebar = () => {
		setSidebarActive(!sidebarActive);
	};

	const closeSidebar = () => {
		setSidebarActive(false);
	};

	return (
		<div className="header">
			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					<img
						className="header-logo"
						src={HeaderLogo}
						alt="Header Logo"
						width="147"
						height="34"
					/>

					<button className="header-btn logo-btn">
						<img src={HeaderLogoBtn} alt="Header Logo Btn" />
					</button>
				</div>

				<div className="header-center">
					<nav className="header-nav">
						<ul className="header-nav-list">
							<li>
								<a href="#ai-agents">How It Works</a>
							</li>
							<li>
								<a href="#features">Features</a>
							</li>
							<li>
								<a href="#roadmap">Roadmap</a>
							</li>
							<li>
								<a href="#community">Community</a>
							</li>
						</ul>
					</nav>
				</div>

				<div className="header-right">
					<Button className="launch-app-btn">DAPP</Button>
					<button
						className="header-btn mobile-sidebar-btn"
						onClick={toggleSidebar}
					>
						<HambergerMenu size="24" color="#ffffff" />
					</button>
				</div>
			</div>

			{/* Sidebar Implementation */}
			<div
				className={`sidebar-backdrop ${sidebarActive ? "active" : ""}`}
				onClick={closeSidebar}
			></div>
			<div className={`sidebar ${sidebarActive ? "active" : ""}`}>
				<div className="sidebar-content">
					<div className="sidebar-header">
						<button
							className="sidebar-close"
							onClick={closeSidebar}
						>
							<Add
								size="40"
								color="#808080"
								className="add-icon"
							/>
						</button>
					</div>

					<div className="sidebar-body">
						<ul className="sidebar-nav">
							<li>
								<a href="#ai-agents" onClick={closeSidebar}>
									How It Works
								</a>
							</li>
							<li>
								<a href="#features" onClick={closeSidebar}>
									Features
								</a>
							</li>
							<li>
								<a href="#roadmap" onClick={closeSidebar}>
									Roadmap
								</a>
							</li>
							<li>
								<a href="#community" onClick={closeSidebar}>
									Community
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{/* End of Sidebar */}
		</div>
	);
}
